export const HOUR_SUFFIX = 'hrs';

export const PICKUP_TIME_RANGE_PLACEHOLDER = `Ej: de 10 ${HOUR_SUFFIX} a 14 ${HOUR_SUFFIX}`;
export const DELIVERY_TIME_RANGE_PLACEHOLDER = `Ej: de 16 ${HOUR_SUFFIX} a 20 ${HOUR_SUFFIX}`;
